var React = require('react');

function ShoePrints (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M0 416a64 64 0 0 0 64 64h32V352H64a64 64 0 0 0-64 64zm337.46-128c-34.91 0-76.16 13.12-104.73 32-24.79 16.38-44.52 32-104.73 32v128l57.53 16c26.21 7.28 53 13.12 80.31 15 32.69 2.31 65.6.67 97.58-6.2C472.9 481.3 512 429.22 512 384c0-64-84.18-96-174.54-96z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M128 96a64 64 0 0 0 64 64h32V32h-32a64 64 0 0 0-64 64zM491.42 7.19c-32-6.87-64.89-8.52-97.58-6.2-27.3 1.93-54.1 7.77-80.31 15L256 32v128c60.2 0 79.94 15.62 104.73 32 28.57 18.88 69.82 32 104.73 32C555.82 224 640 192 640 128c0-45.22-39.1-97.3-148.58-120.81z","className":"fa-primary","key":2})]);
}

ShoePrints.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = ShoePrints;

ShoePrints.default = ShoePrints;
